import mixpanel from 'mixpanel-browser';

mixpanel.init(
  process.env.REACT_APP_MIXPANEL_TOKEN || '5a0b8ad0b55f8d8dc74e1eef096cd3d6',
  // { debug: true },
);
export default mixpanel;
